import React, { useState } from "react";
import { useRef } from "react";
import { FiChevronDown } from "react-icons/fi";
import { AiOutlineSearch } from "react-icons/ai";
import { VscBell } from "react-icons/vsc";
import { IoPersonSharp } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";

import { FaFacebookF } from "react-icons/fa";
import { AiFillYoutube } from "react-icons/ai";
import { AiFillLinkedin } from "react-icons/ai";
import { AiFillInstagram } from "react-icons/ai";

import { BsFillPersonFill } from "react-icons/bs";
import { FcSettings } from "react-icons/fc";
import { BiLogOut } from "react-icons/bi";

import Search from "../Search/Search";

import zununLogo from "../../assests/images/zunun.png";

import NotificationModal from "../NotificationModal/NotificationModal";
import useOnClickOutside from "../../CustomHooks/useOnClickOutside";
import "./Navbar.scss";

export default function Navbar() {
  const [showSearchBar, setShowSearchBar] = useState<boolean>(false);
  const [showNotification, setShowNotification] = useState<boolean>(false);
  const [showDropDownMenu, setShowDropDownMenu] = useState<boolean>(false);
  const menuOptionRef = useRef<null | HTMLDivElement>(null);
  const menuButtonRef = useRef<null | HTMLDivElement>(null);

  const handleOutsideClick = (clickedEvent) => {
    if (menuButtonRef) setShowDropDownMenu(false);
  };

  useOnClickOutside(menuOptionRef, handleOutsideClick);

  const handleToggleSearchBar = () => {
    setShowSearchBar((preState) => !preState);
  };

  const handleSearch = () => {};

  const handleNotificationToggle = () => {
    setShowNotification((preState) => !preState);
  };

  const handleDropDownMenuClick = () => {
    setShowDropDownMenu((preState) => !preState);
  };

  return (
    <div className="navbar">
      <div className="nav_header">
        <div className="nav_logo">
          <img className="main_logo" src={zununLogo} alt="logo" />
          <span className="logo_text">Stdnt</span>
        </div>

        <div className="package_container">
          <div className="package_name">
            Leet Course
            <span className="drop_icon">
              <FiChevronDown />
            </span>
          </div>

          <p className="expire_data_container">Expired on 28 Nov 2022</p>
        </div>
      </div>

      <div className="menu_container">
        <div className="search_box_wrapper">
          {showSearchBar && (
            <div className="search_bar_wrapper">
              <Search
                handleSearch={handleSearch}
                handleClose={handleToggleSearchBar}
              />
            </div>
          )}
          {!showSearchBar && (
            <AiOutlineSearch onClick={handleToggleSearchBar} />
          )}
        </div>
        <div
          className="notification_icon_wrapper "
          onClick={handleNotificationToggle}
        >
          <VscBell />
        </div>
        <div
          className="profile_wrapper"
          onClick={handleDropDownMenuClick}
          ref={menuOptionRef}
        >
          <IoPersonSharp />
          {showDropDownMenu && (
            <div className="navbar_menu_container custom_card">
              <ul>
                <li>
                  <BsFillPersonFill /> Profile
                </li>
                <li>
                  <FcSettings />
                  Settings
                </li>
                <li>
                  <FcSettings /> Dark mode
                </li>
                <li>
                  <BiLogOut />
                  Log out
                </li>
              </ul>
              <div className="social_link_container">
                <div className="facebook">
                  <FaFacebookF />
                </div>
                <div className="instagram">
                  <AiFillInstagram />
                </div>
                <div className="youtube">
                  <AiFillYoutube />
                </div>
                <div className="linkedin">
                  <AiFillLinkedin />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* modals */}
      <NotificationModal
        modalTitle={"Notification"}
        showModal={showNotification}
        handleModalToggle={handleNotificationToggle}
      />
    </div>
  );
}
